module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-section"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.title) ? _c('h3', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subTitle) ? _c('p', {
    staticClass: "sub-title",
    domProps: {
      "innerHTML": _vm._s(_vm.subTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.btnText) ? _c('section-button', {
    attrs: {
      "btnText": _vm.btnText
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-6 box"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.heading) ? _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('p', {
    staticClass: "small",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.button) ? _c('button', [_vm._v(_vm._s(_vm.button))]) : _vm._e()])]), _vm._v(" "), (_vm.getStarted) ? _c('div', {
    staticClass: "img-container",
    style: ({
      backgroundImage: 'url(' + _vm.image + ')'
    })
  }) : _c('div', {
    staticClass: "col-xs-6 img-container",
    class: {
      'col-sm-8': _vm.removeSpacer, 'col-sm-4': !_vm.removeSpacer
    }
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "image"
    }
  }, [(_vm.wireframe) ? _c('div', [(_vm.removeSpacer) ? _c('div', [_c('svg', {
    staticStyle: {
      "opacity": "0",
      "display": "inline-block"
    },
    attrs: {
      "viewBox": "0 0 694.10303 400.01801",
      "id": 'svg' + _vm.index,
      "xmlns": "http://www.w3.org/2000/svg"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg1)
    }
  }), _vm._v(" "), _c('svg', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "viewBox": "0 0 694.10303 400.01801",
      "id": 'ip' + _vm.index,
      "xmlns": "http://www.w3.org/2000/svg"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg2)
    }
  })]) : _c('div', [_c('svg', {
    staticStyle: {
      "opacity": "0",
      "display": "inline-block"
    },
    attrs: {
      "viewBox": "0 0 210 429",
      "id": 'svg' + _vm.index,
      "xmlns": "http://www.w3.org/2000/svg"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg1)
    }
  }), _vm._v(" "), _c('svg', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "viewBox": "0 0 210 429",
      "id": 'ip' + _vm.index,
      "xmlns": "http://www.w3.org/2000/svg"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg2)
    }
  })])]) : _c('transition', {
    attrs: {
      "name": "bounce",
      "enter-active-class": _vm.animEnter,
      "leave-active-class": _vm.animLeave
    }
  }, [(_vm.enter) ? _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 hidden-sm hidden-xs spacer"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29826628"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSection.vue
// module id = 78
// module chunks = 0